/*
 * @Description:
 * @Date: 2025-07-23 16:05:30
 */

import http from '@/utils/http/axios';
import { PayedOrderMap } from './types';
import router from '@/router';

enum Api {
  fkAspPayedOrderMap = '/front-end/invoice/fe/asp/payedOrderMap', // 服务商-所有类型订单
  fkSupplierPayedOrderMap = '/front-end/invoice/fe/supplier/payedOrderMap', // 供应商-项目订单
  fkComprehensivePayedOrderMap = '/front-end/invoice/fe/supplier/comprehensive/payedOrderMap', // 供应商-综合服务费

  orderPayDetailExport = '/front-end/asp-order-pay-detail-export/orderPayDetailExport', // 单条下载支付详情
  orderPayDetailExportSupplier = '/front-end/supplier-order-pay-detail-export/orderPayDetailExport', // 单条下载支付详情供应商

  batchOrderPayDetailExport = '/front-end/asp-order-pay-detail-export/batchOrderPayDetailExport', // 批量下载支付详情
  batchOrderPayDetailExportSupplier = '/front-end/supplier-order-pay-detail-export/batchOrderPayDetailExport', // 批量下载支付详情供应商

  batchDownload = '/front-end/asp-receipt-download/batchDownload', // 批量下载回单
  supplierBatchDownload = '/front-end/supplier-receipt-download/batchDownload', // 供应商批量下载回单

  limitOrderExport = '/front-end/limit/order/export' // 导出超限人员列表
}
const getTaxType = () => {
  // 获取订单来自劳务还是经营taxType
  return { taxType: router.currentRoute.value.meta.taxType };
};
/**
 * 导出
 */
export const limitOrderExport = params =>
  http.download(
    {
      url: Api.limitOrderExport,
      method: 'GET',
      params
    },
    {
      isShowSuccessMessage: true
    }
  );
export const fkAspPayedOrderMap: PayedOrderMap = async (params, options) =>
  http.request(
    {
      url: Api.fkAspPayedOrderMap,
      method: 'POST',
      params
    },
    options
  );
export const fkSupplierPayedOrderMap: PayedOrderMap = async (params, options) =>
  http.request(
    {
      url: Api.fkSupplierPayedOrderMap,
      method: 'POST',
      params
    },
    options
  );
export const fkComprehensivePayedOrderMap: PayedOrderMap = async (
  params,
  options
) =>
  http.request(
    {
      url: Api.fkComprehensivePayedOrderMap,
      method: 'POST',
      params: {
        ...getTaxType(),
        ...params
      }
    },
    options
  );

export const orderPayDetailExport = async (params: {
  payPassagewayCode: number; //支付渠道：条件必须选择，网银支付和非网银支付导出的表头不一样
  aspOrderIdList: number[]; //项目服务费订单ID集合
}) =>
  http.download(
    {
      url: Api.orderPayDetailExport,
      method: 'POST',
      params: {
        ...getTaxType(),
        ...params
      }
    },
    {
      isShowSuccessMessage: true
    }
  );
export const orderPayDetailExportSupplier = async (params: {
  payPassagewayCode: number; //支付渠道：条件必须选择，网银支付和非网银支付导出的表头不一样
  supplierOrderIdList: number[]; //项目服务费订单ID集合
}) =>
  http.download(
    {
      url: Api.orderPayDetailExportSupplier,
      method: 'POST',
      params: {
        ...getTaxType(),
        ...params
      }
    },
    {
      isShowSuccessMessage: true
    }
  );
export const batchOrderPayDetailExportSupplier = async (params: {
  payPassagewayCode: number; //支付渠道：条件必须选择，网银支付和非网银支付导出的表头不一样
  supplierOrderList: number[]; //项目服务费订单ID集合
}) =>
  http.download(
    {
      url: Api.batchOrderPayDetailExportSupplier,
      method: 'POST',
      params: {
        ...getTaxType(),
        ...params
      }
    },
    {
      isShowSuccessMessage: true
    }
  );

export const batchOrderPayDetailExport = async (params: {
  downLoadType: number; //1:汇总  2:分批
  payPassagewayCode: number; //支付渠道：条件必须选择，网银支付和非网银支付导出的表头不一样
  aspOrderList: {
    projectId: number;
    aspOrderId: number;
  }[]; //项目服务费订单ID集合
}) =>
  http.download(
    {
      url: Api.batchOrderPayDetailExport,
      method: 'POST',
      params: {
        ...getTaxType(),
        ...params
      }
    },
    {
      isShowSuccessMessage: true
    }
  );

export const batchDownloadReceipt = async (params: {
  fileName: string; //文件名称
  downloadType: number;
  //下载业务类型：参考枚举AspDownloadEnum
  //   501 - 服务商-个税预扣税款明细-一般劳务-批量下载回单
  //   502 - 服务商-个税预扣税款明细-连续劳务-批量下载回单
  //   503 - 服务商-已完结订单-批量下载回单
  //   504 - 服务商-已完结订单-查看明细-批量下载回单
  //   505 - 服务商-终端支付管理-批量下载回单
  downloadList?: {
    id: number;
    aspOrderId: number;
    aspSupplierOrderId: number;
    orderType: number;
  }[]; //业务数据ID集合
  queryParam?: string; //查询条件(JSON格式字符串)
}) =>
  http.request(
    {
      url: Api.batchDownload,
      method: 'POST',
      params: {
        ...getTaxType(),
        ...params
      }
    },
    {
      isShowSuccessMessage: true
    }
  );

export const supplierBatchDownload = async (params: {
  fileName: string; //文件名称
  downloadType: number;
  // 下载业务类型：参考枚举SupplierDownloadEnum
  // 701 - 供应商-项目服务费订单-已完结订单-批量下载回单
  // 702 - 供应商-项目服务费订单-订单查看明细-批量下载回单
  // 703 - 供应商-综合服务费订单-批量下载回单
  downloadList: {
    id: number;
    aspOrderId: number;
    aspSupplierOrderId: number;
    supplierOrderId: number;
    orderType: number;
  }[]; //业务数据ID集合
}) =>
  http.request(
    {
      url: Api.supplierBatchDownload,
      method: 'POST',
      params: {
        ...getTaxType(),
        ...params
      }
    },
    {
      isShowSuccessMessage: true
    }
  );
